import ReminderActionModel from '@/common/models/rules/actions/reminder-action-model';

export default class ResetReminderActionModel extends ReminderActionModel {
}
